export default __webpack_public_path__ + "static/media/genie-logo.6d0794c0.svg";